module.exports = __webpack_public_path__ + "img/10.a42e4993.jpg";